<template>
  <v-select
    v-model="selected"
    :label="label"
    :reduce="reduce"
    :options="searchText ? localOptions : options.results"
    :get-option-label="getOptionLabel"
    :placeholder="placeholder"
    :multiple="multiple"
    :disabled="disabled"
    @open="onOpen"
    @close="onClose"
    @search="
      (val, loading) => {
        loading(true)
        fetchOptions(val).then(() => loading(false))
      }
    "
    @input="onSelected"
  >
    <template #list-footer>
      <li
        v-show="options.next"
        ref="load"
        class="loader"
      >
        Loading more options...
      </li>
    </template>
  </v-select>
</template>

<script>
import VSelect from 'vue-select'

export default {
  components: {
    VSelect,
  },
  props: {
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    options: {
      type: Object,
      required: false,
      default() {
        return {
          next: null,
          timer: null,
        }
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    getOptionLabel: {
      type: Function,
      required: false,
    },
    reduce: {
      type: Function,
      required: false,
      default: v => v,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    lazyFetchData: {
      type: Function,
      required: false,
    },
    pageSize: {
      type: Number,
      required: false,
      default: 15,
    },
    search: {
      type: Function,
      required: false,
      default() {},
    },
  },
  data() {
    return {
      observer: null,
      selectLoading: false,
      localOptions: [],
      searchText: '',
      selected: null,
    }
  },
  mounted() {
    this.observer = new IntersectionObserver(
      async ([{ isIntersecting, target }]) => {
        if (!isIntersecting || this.selectLoading) {
          return
        }
        if (!this.options.next) {
          return
        }
        this.selectLoading = true
        const ul = target.offsetParent
        const { scrollTop } = target.offsetParent
        await this.lazyFetchData({
          page: this.options.next,
          page_size: this.pageSize,
        })
        this.selectLoading = false
        await this.$nextTick()
        ul.scrollTop = scrollTop
      },
    )
  },
  methods: {
    onOpen() {
      this.$nextTick(() => {
        if (this.$refs.load) {
          this.observer.observe(this.$refs.load)
        }
      })
    },
    onSelected() {
      this.$emit('update:itemSelected', this.selected)
      this.$emit('input', this.selected)
    },
    onClose() {
      this.observer.disconnect()
    },
    fetchOptions(val) {
      this.searchText = val
      if (this.timer) {
        clearTimeout(this.timer)
      }

      return new Promise(resolve => {
        // eslint-disable-next-line consistent-return
        this.timer = setTimeout(() => {
          if (!this.searchText) {
            return resolve()
          }
          this.search({ search: val })
            .then(data => {
              this.localOptions = data.results
            })
            .finally(() => {
              resolve()
            })
        }, 500)
      })
    },
  },
}
</script>

<style scoped>
.loader {
  text-align: center;
  color: #bbbbbb;
}
</style>
